/* tslint:disable */
/* eslint-disable */
/* @relayHash a46e8eac5c77ad8c8e1d4eb5ddb76b96 */

import { ConcreteRequest } from "relay-runtime";
export type CreateStudyRecordInput = {
    worksheetId: string;
    clientMutationId?: string | null;
};
export type CreateStudyRecordMutationVariables = {
    input: CreateStudyRecordInput;
};
export type CreateStudyRecordMutationResponse = {
    readonly createStudyRecord: {
        readonly studyRecord: {
            readonly id: string;
        } | null;
    } | null;
};
export type CreateStudyRecordMutation = {
    readonly response: CreateStudyRecordMutationResponse;
    readonly variables: CreateStudyRecordMutationVariables;
};



/*
mutation CreateStudyRecordMutation(
  $input: CreateStudyRecordInput!
) {
  createStudyRecord(input: $input) {
    studyRecord {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateStudyRecordInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createStudyRecord",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateStudyRecordPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "studyRecord",
        "storageKey": null,
        "args": null,
        "concreteType": "StudyRecord",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateStudyRecordMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateStudyRecordMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateStudyRecordMutation",
    "id": null,
    "text": "mutation CreateStudyRecordMutation(\n  $input: CreateStudyRecordInput!\n) {\n  createStudyRecord(input: $input) {\n    studyRecord {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '34622c659fe02a2b906999361320ddf7';
export default node;
